// extracted by mini-css-extract-plugin
module.exports = {"container":"MainColumn_container_2W3t8"};